module.exports = __webpack_public_path__ + "static/img/home_type_icon_zcyzd.7f631afb.webp";